import { AppRoutes } from '../../core/routes/routes';

export const basePath = `creator`;

export const baseUrl = `/${basePath}`;

export const routes = {
  dashboard: {
    path: 'dashboard',
    url: () => `${baseUrl}/dashboard`,
  },
  inbox: {
    path: 'inbox',
    url: () => `${baseUrl}/inbox`,
  },
  applications: {
    index: {
      path: 'applications',
      url: () => `${baseUrl}/applications`,
    },
    detail: {
      root: {
        path: 'applications/:id',
        url: (args: { id: string }) => `${baseUrl}/applications/${args.id}`,
      },
      overview: {
        path: 'applications/:id/overview',
        url: (args: { id: string }) => `${baseUrl}/applications/${args.id}/overview`,
      },
      chat: {
        path: 'applications/:id/chat',
        url: (args: { id: string }) => `${baseUrl}/applications/${args.id}/chat`,
      },
    },
  },
  marketplace: {
    index: {
      path: 'marketplace',
      url: () => `${baseUrl}/marketplace`,
    },
    listing: {
      path: 'marketplace/:listingId',
      url: (args: { listingId: string }) => `${baseUrl}/marketplace/${args.listingId}`,
    },
  },
  settings: {
    root: {
      path: 'settings',
      url: () => `${baseUrl}/settings`,
    },
    bank: {
      overview: {
        path: 'bank',
        url: () => `${baseUrl}/settings/bank`,
      },
      onboarded: {
        path: 'bank/onboarded',
        url: () => `${baseUrl}/settings/bank/onboarded`,
      },
    },
    profile: {
      edit: {
        path: 'profile',
        url: () => `${baseUrl}/settings/profile`,
      },
      preview: {
        path: 'profile/preview',
        url: () => `${baseUrl}/settings/profile/preview`,
      },
    },
    account: {
      path: 'account',
      url: () => `${baseUrl}/settings/account`,
    },
    contact: {
      path: 'contact',
      url: () => `${baseUrl}/settings/contact`,
    },
  },
  help: {
    index: {
      path: 'help',
      url: () => `${baseUrl}/help`,
    },
  },
} as const satisfies AppRoutes;
